import { useMemo } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';
import {
  formatClinicDateLong,
  shiftClinicWeekYmd,
  todayYmdInClinic,
  weekDaysClinic,
} from '../lib/clinicTime';

export default function AppointmentWeekDayPicker({ selectedYmd, onSelectYmd, className = '' }) {
  const todayYmd = todayYmdInClinic();
  const weekDays = useMemo(
    () => weekDaysClinic(selectedYmd, selectedYmd, todayYmd),
    [selectedYmd, todayYmd],
  );

  const shiftWeek = (deltaWeeks) => {
    onSelectYmd(shiftClinicWeekYmd(selectedYmd, deltaWeeks));
  };

  return (
    <div className={className} data-testid="appointment-week-day-picker">
      <div className="flex items-center justify-between gap-2 mb-2">
        <Button
          type="button"
          variant="outline"
          size="icon"
          className="h-8 w-8 shrink-0"
          aria-label="Semana anterior"
          onClick={() => shiftWeek(-1)}
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>
        <p className="text-sm text-muted-foreground capitalize text-center flex-1">
          {formatClinicDateLong(selectedYmd)}
        </p>
        <Button
          type="button"
          variant="outline"
          size="icon"
          className="h-8 w-8 shrink-0"
          aria-label="Semana siguiente"
          onClick={() => shiftWeek(1)}
        >
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
      <div className="grid grid-cols-7 gap-1 sm:gap-2">
        {weekDays.map((d) => (
          <button
            key={d.ymd}
            type="button"
            onClick={() => onSelectYmd(d.ymd)}
            className={`rounded-xl border px-1 py-2 sm:py-2.5 text-center transition-colors ${
              d.isSelected
                ? 'border-primary bg-primary text-primary-foreground shadow-sm'
                : d.isToday
                  ? 'border-primary/50 bg-primary/10 hover:bg-primary/15'
                  : 'border-border bg-card hover:bg-muted/60'
            }`}
            aria-pressed={d.isSelected}
            aria-label={`${d.label} ${d.dayNum}`}
          >
            <div className="text-[10px] sm:text-xs font-medium opacity-90">{d.label}</div>
            <div className="text-base sm:text-lg font-bold tabular-nums leading-tight">{d.dayNum}</div>
          </button>
        ))}
      </div>
      {selectedYmd !== todayYmd ? (
        <div className="mt-2 flex justify-center">
          <Button
            type="button"
            variant="link"
            size="sm"
            className="h-auto p-0 text-xs"
            onClick={() => onSelectYmd(todayYmd)}
          >
            Volver a hoy
          </Button>
        </div>
      ) : null}
    </div>
  );
}
